import { useEffect, useState } from 'react';
import { getPublicSettings } from '../api/settings-service';
import { EMPTY_PUBLIC_SETTINGS, type PublicSettings } from '../models/public-settings';

interface PublicSettingsState {
    settings: PublicSettings;
    loading: boolean;
}

/**
 * Company name, contacts and links, read once from the anonymous settings route.
 *
 * A failure yields an empty map rather than an error screen: the page has its own copy and layout
 * to show, and a missing phone number is not a reason to hide the site.
 */
export function usePublicSettings(): PublicSettingsState {
    const [settings, setSettings] = useState<PublicSettings>(EMPTY_PUBLIC_SETTINGS);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const controller = new AbortController();

        getPublicSettings(controller.signal)
            .then(setSettings)
            .catch(() => setSettings(EMPTY_PUBLIC_SETTINGS))
            .finally(() => {
                if (!controller.signal.aborted) {
                    setLoading(false);
                }
            });

        return () => controller.abort();
    }, []);

    return { settings, loading };
}
